import * as React from 'react'
import classnames from 'classnames'

import cls from './HeadlineDesc.module.scss'

const UikHeadline = ({ children, className, Component, ...rest }) => (
  <Component className={classnames(cls.wrapper, className)} {...rest}>
    {children}
  </Component>
)

UikHeadline.defaultProps = {
  className: null,
  Component: 'p',
}

export default UikHeadline
